import sha1 from 'js-sha1'
export const getApiToken = (client_id, url, ts) => {
  let beginD = url.indexOf('//')
  beginD = beginD < 0 ? 0 : beginD + 2
  var method = url.substr(beginD, url.length - beginD)

  const beginF = method.indexOf('/')
  method = method.substr(beginF + 1, url.length - beginF)
  method = method.toLowerCase()
  var arr = [method, ts, client_id, '64F2D7C5CF27083A']
  arr.sort()
  var str = arr.join('')
  str = sha1(str).toLowerCase()
  return str
}
